import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AnalyticsService } from '../../../../../../shared/modules/analytics/services/analytics.service';

@Component({
  selector: 'evc-quote-technical-details-continue-later',
  templateUrl: './continue-later.component.html',
  styleUrls: ['./continue-later.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContinueLaterComponent implements OnInit {
  @Input() email: string;
  @Output() resend: EventEmitter<string> = new EventEmitter<string>();
  @Output() goBack: EventEmitter<string> = new EventEmitter<string>();

  constructor(private analyticsService: AnalyticsService) {}

  ngOnInit(): void {
    this.analytics();
  }

  public navigateBack(): void {
    this.goBack.emit();
  }

  resendEmail() {
    this.resend.emit();
  }

  private analytics() {
    this.analyticsService.push({
      event: 'evcQuote-Step',
      page: {
        step: 'technical-details-continue-later',
      },
    });
  }
}
